/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamOperationalFault } from './oralExamOperationalFault';

export type OralExamAgentControlStateResponseOperationalFault = OralExamOperationalFault | null;
